import {cssTheme} from '@logistics-frontend/blocks/theme'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const footer = css`
  box-shadow: ${cssTheme.shadows.topNormal};
  margin-block-start: ${spacing(2)} !important;
  padding-block-start: ${spacing(1)};
`

export const image = css`
  padding: ${spacing(1)};
`

export const truncatedText = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
